import ImageSanctifier from './components/ImageSanctifier';

function App() {
  return (
    <div className="App">
      <ImageSanctifier />
    </div>
  );
}

export default App;